import React from "react";
import classNames from "classnames";
import { SectionSplitProps } from "../../utils/SectionProps";
import SectionHeader from "./partials/SectionHeader";
import Image from "../elements/Image";

const propTypes = {
  ...SectionSplitProps.types,
};

const defaultProps = {
  ...SectionSplitProps.defaults,
};

const FeaturesSplit = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {
  const outerClasses = classNames(
    "features-split section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "features-split-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const splitClasses = classNames(
    "split-wrap",
    invertMobile && "invert-mobile",
    invertDesktop && "invert-desktop",
    alignTop && "align-top"
  );

  const sectionHeader = {
    title: "Bot that just works!",
    paragraph:
      "Each and every feature in Gamer is designed as a separate piece. You can combine multiple pieces together to create amazing possibilities!",
  };

  return (
    <section {...props} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>
            <div className="split-item">
              <div
                className="split-item-content center-content-mobile reveal-from-left"
                data-reveal-container=".split-item"
              >
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">Lightning fast!</div>
                <h3 className="mt-0 mb-12">Reaction Roles</h3>
                <p className="m-0">
                  Reaction roles are a fun, easy and visual way for users to assign roles to themselves without having
                  to go through the effort of having to type .give role. Once setup, users can now join your server and
                  give themself the right roles.
                </p>
              </div>
              <div
                className={classNames(
                  "split-item-image center-content-mobile reveal-from-bottom",
                  imageFill && "split-item-image-fill"
                )}
                data-reveal-container=".split-item"
              >
                <Image
                  src={require("./../../assets/images/reactionrole.png")}
                  alt="Features split 01"
                  width={528}
                  height={396}
                />
              </div>
            </div>

            <div className="split-item">
              <div
                className="split-item-content center-content-mobile reveal-from-right"
                data-reveal-container=".split-item"
              >
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Send A @alert When Someone Changes Roles
                </div>
                <h3 className="mt-0 mb-12">Role Messages</h3>
                <p className="m-0">
                  Setup customizable messages to be sent when a user gains or loses a role! Role messages can be used as
                  welcome or goodbye messages for specific roles/groups on your server. For example, you can use this to
                  give players a specific code to enter for their specific region role. Mix this with your XP system to
                  alert users that are inactive! And so much more!
                </p>
              </div>
              <div
                className={classNames(
                  "split-item-image center-content-mobile reveal-from-bottom",
                  imageFill && "split-item-image-fill"
                )}
                data-reveal-container=".split-item"
              >
                <Image
                  src={require("./../../assets/images/rolemessages.png")}
                  alt="Features split 02"
                  width={528}
                  height={396}
                />
              </div>
            </div>

            <div className="split-item">
              <div
                className="split-item-content center-content-mobile reveal-from-left"
                data-reveal-container=".split-item"
              >
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">A Role Set For Everyone!</div>
                <h3 className="mt-0 mb-12">Automatically Manage Your Roles With Role Sets</h3>
                <p className="m-0">- Use a Unique role set to make sure users can only have one role in that set.</p>
                <p className="m-0">
                  - Use the Grouped role sets to assign a Player role whenever a user gains a role from the reaction
                  role!
                </p>
                <p className="m-0">
                  - Use the Default role sets to automatically assign a role when a user does not have any role in that
                  set.
                </p>
                <p className="m-0">
                  - Use the Required role sets to make sure the user has the required role in order to gain another
                  role.
                </p>
              </div>
              <div
                className={classNames(
                  "split-item-image center-content-mobile reveal-from-bottom",
                  imageFill && "split-item-image-fill"
                )}
                data-reveal-container=".split-item"
              >
                <Image
                  src={require("./../../assets/images/rolesets.gif")}
                  alt="Features split 03"
                  width={528}
                  height={396}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

FeaturesSplit.propTypes = propTypes;
FeaturesSplit.defaultProps = defaultProps;

export default FeaturesSplit;
